import { FieldValues } from 'react-hook-form';
import { cn } from '@anytag/shared-utils';
import { Form } from '@anytag/shared-atoms';
import { MoreFilterPopover } from './more-filter-popover';

const Provider = <T extends FieldValues>({
  style,
  className,
  ...restProps
}: React.ComponentProps<typeof Form.Provider<T>>) => (
  <Form.Provider<T>
    className={cn('relative filter-form-provider rounded-b-none bg-white px-2 py-1', className)}
    {...restProps}
  />
);

export * from './types';
export const Filter = {
  Provider,
  MoreFilterPopover
};
